import {
  RatingConfigurator,
  CommentConfigurator,
  MultipleSelectionConfigurator
} from '@bingads-webui-campaign-react/survey-factory-tools';

export const reportingWebuiUserSurveyConfig = (options) => {
  const {
    i18n,
  } = options;
  return {
    featureArea: 'ReportingWebuiUserSurvey',
    style: {
      root: {
        maxWidth: 480,
      },
    },
    others: {
      combineTextInputToComment: true,
    },
    questions: [
      {
        isRequired: true,
        Type: RatingConfigurator,
        key: 'q1',
        page: 0,
        position: 0,
        getTitle: () => i18n.getString(_TL_('How satisfied are you with the reporting features in Microsoft Advertising?')),
        isVisible: () => true,
        options: [
          {
            key: '5',
            text: i18n.getString(_TL_('Very satisfied')),
            rating: 1.0,
          },
          {
            key: '4',
            text: i18n.getString(_TL_('Moderately satisfied')),
            rating: 0.8,
          },
          {
            key: '3',
            text: i18n.getString(_TL_('Neutral')),
            rating: 0.6,
          },
          {
            key: '2',
            text: i18n.getString(_TL_('Moderately dissatisfied')),
            rating: 0.4,
          },
          {
            key: '1',
            text: i18n.getString(_TL_('Very dissatisfied')),
            rating: 0.2,
          },
        ],
      },
      {
        isRequired: false,
        Type: CommentConfigurator,
        key: 'q2',
        page: 0,
        position: 1,
        getTitle: () => i18n.getString(_TL_('Please elaborate on your experience:')),
        isVisible: answers => ['3', '2', '1'].includes(answers.q1.selectedOption),
        maxLength: 2000,
        data: {
        },
      },
      {
        isRequired: false,
        Type: MultipleSelectionConfigurator,
        key: 'q3',
        page: 1,
        position: 0,
        getTitle: () => i18n.getString(_TL_('Which features do you primarily use to track your campaign performance?')),
        isVisible: true,
        options: [
          {
            key: '8',
            text: i18n.getString(_TL_('Overview page')),
          },
          {
            key: '7',
            text: i18n.getString(_TL_('Performance grids (e.g., campaign grid, ad group grid, etc.)')),
          },
          {
            key: '6',
            text: i18n.getString(_TL_('Reports from the Reporting tab ')),
          },
        ],
      },
      {
        Type: CommentConfigurator,
        isRequired: false,
        key: 'q4',
        page: 1,
        position: 1,
        getTitle: () => i18n.getString(_TL_('What additional features or enhancements would you like to see in Microsoft Advertising reporting? Please elaborate below.')),
        maxLength: 2000,
        data: {
        },
      },
    ],
  };
};
